export const letterQ = {
  nouns: [],
  verbs: [],
  examples: {
    nominative: [],
    accusative: [],
    dative: [],
    translations: [],
    conjugations: []
  }
}
